export class LoadFileINModel {
    filePath: string;
}
